<template>
  <div class="chart-page">
    <div class="chart-content">
      <span
        class="content-item"
        :class="{[item.className]: true, active: item.level == level}"
        v-for="item in yLineClass"
        :key="item.level"
      >
        <Texts
          bold
          small-size
          theme-color
          class="item-popTip"
          v-if="item.level == level && childName"
          v-text="
            childName.length > 6 ? childName.substring(0, 6) + '...' : childName
          "
        ></Texts>
      </span>
    </div>
    <div class="chart-xLine">
      <span
        class="xLine-item"
        :style="{backgroundColor: item}"
        v-for="(item, index) in xLineBgColor"
        :key="index"
      ></span>
    </div>
    <div class="chart-desc">
      <Texts class="desc-item" v-for="(item, index) in xDesc" :key="index">{{
        item
      }}</Texts>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Chart',
  data() {
    return {
      xDesc: ['较差', '一般', '较好'],
      xLineBgColor: ['#FF777B', '#FFD759', '#8FE667'],
      yLineClass: [
        {
          className: 'content-item-level1',
          level: 3
        },
        {
          className: 'content-item-level2',
          level: 2
        },
        {
          className: 'content-item-level3',
          level: 1
        }
      ]
    };
  },
  props: {
    childName: {
      type: String,
      default: '时代峻峰你'
    },
    level: {
      type: [String, Number],
      default: 3
    }
  }
};
</script>

<style lang="less" scoped>
@level1Color: #ff777b;
@level2Color: #ffd759;
@level3Color: #8fe667;
.chart-page {
  margin-bottom: 50px;
  .chart-content {
    display: flex;
    align-items: flex-end;
    position: relative;
    overflow: hidden;
    &:before {
      content: '';
      width: 130%;
      height: 100%;
      position: absolute;
      right: 0;
      bottom: 0;
      transform: translateY(-32%);
      border-radius: 0 0 70% 10%;
      background: white;
      z-index: 1;
    }
    .content-item {
      flex: 1;
      position: relative;
      &.active:before {
        content: '';
        width: 1px;
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
      &.active:after {
        content: '';
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #fff;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
      }
      &.active {
        .item-popTip {
          position: absolute;
          background: #f5f6fa;
          border-radius: 8px;
          padding: 10px 14px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
          white-space: nowrap;
          display: flex;
          justify-content: center;
          min-width: 100px;
          &:before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            left: 50%;
            margin-left: -12px;
            bottom: 0;
            transform: translateY(98%);
            border: 12px solid transparent;
            border-top: 12px solid #f5f6fa;
          }
        }
      }
    }
    .content-item-level1 {
      height: 78px;
      background: rgba(255, 119, 123, 0.1);
      &.active:before {
        background: @level1Color;
      }
      &.active:after {
        border: 4px solid @level1Color;
        top: 5px;
      }
      &.active {
        .item-popTip {
          top: -70px;
        }
      }
    }
    .content-item-level2 {
      height: 142px;
      background: rgba(255, 215, 89, 0.1);
      &.active:before {
        background: @level2Color;
      }
      &.active:after {
        border: 4px solid @level2Color;
        top: 52px;
      }
      &.active {
        .item-popTip {
          top: -20px;
        }
      }
    }
    .content-item-level3 {
      height: 202px;
      background: rgba(143, 230, 103, 0.1);
      &.active:before {
        background: @level3Color;
      }
      &.active:after {
        border: 4px solid @level3Color;
        top: 67px;
      }
      &.active {
        .item-popTip {
          top: 0px;
        }
      }
    }
  }

  .chart-desc {
    display: flex;
    margin: 10px 0;
    .desc-item {
      flex: 1;
      text-align: center;
    }
  }
  .chart-xLine {
    display: flex;
    .xLine-item {
      flex: 1;
      height: 20px;
      background: #ff777b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Chart/index.vue